module.exports = __webpack_public_path__ + "img/4-quad.cf5ee15c.png";